import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorNotificationService } from '../../core/services/error-notification.service';
import { CommonModule } from '@angular/common';
import { AuthFooterComponent } from '../../shared/ui/auth-layout/auth-footer.component';
import { AuthHeaderComponent } from '../../shared/ui/auth-layout/auth-header.component';

@Component({
    standalone: true,
    selector: 'app-error-view',
    imports: [CommonModule, AuthFooterComponent, AuthHeaderComponent],
    templateUrl: './error-view.component.html',
    styleUrl: './error-view.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorViewComponent implements OnInit {
  loading = signal(false);
  @Input() errorMessage: string = '';

  constructor(
    private router: Router,
    private errorSvc: ErrorNotificationService,
  ) {}

  ngOnInit(): void {
    this.errorSvc.errorNotification$.subscribe((e) => {
      this.errorMessage = e;
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }
}
